export default __webpack_public_path__ + "98ebb0b3475ffa283cec1745d73ad69b.jpg";